// eslint-disable-next-line import/no-unresolved
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl, apiUrl } from '../../utils/api'
import { apiBasePath } from '../BasicUrl';




const signInApi = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        addLogin: build.mutation({
            query: (data) => ({
                url: `${apiUrl.signIn}`,
                method: "POST",
                body: data,
            })
        }),
        deleteAccount: build.mutation({
            query: (data) => ({
                url: `${apiUrl.deleteAccount}`,
                method: "POST",
                body: data,
            })
        }),
    }),
    overrideExisting: false,
});
export const { useAddLoginMutation, useDeleteAccountMutation } = signInApi;








// const extendedApi = apiBasePath.injectEndpoints({
//     endpoints: (build) => ({
//         addLogin: build.mutation({
//             query: (data) => ({
//                 url: `${apiUrl.signIn}`,
//                 method: "POST",
//                 body: data,
//             })
//         }),
//     }),
//     overrideExisting: false,
// });